// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';
import { withStyles } from '@material-ui/core/styles';

import moment from 'moment';
import styles from './styles';

class RedemptionHistory extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    balanceLogs: PropTypes.array,
  };

  static defaultProps = {
    classes: {},
    balanceLogs: [],
  };

  getDate = (date) => {
    // Explicit format, not 'L' - that follows moment's locale and renders
    // US MM/DD/YYYY by default, which read as the wrong date to UK shops.
    return moment(date).format('DD/MM/YYYY');
  };

  renderVoucher = (balanceLog) => {
    const { classes } = this.props;

    return (
      <div key={uuidv4()} className={classes.row}>
        {/* Which voucher the money came off. Rows written before vouchers
            carried their own balance came out of the pooled customer balance
            and have no voucher to name, so they show a dash rather than a
            misleading blank. */}
        <p className={classes.text}>{balanceLog.VoucherCode || '-'}</p>
        <p className={classes.text}>{`£${parseFloat(balanceLog.Value).toFixed(2)}`}</p>
        <p className={classes.text}>{`${this.getDate(balanceLog.OperationDate)}`}</p>
      </div>
    );
  }

  render() {
    const {
      classes,
      balanceLogs,
    } = this.props;

    const headers = ['voucher', 'value', 'date'];

    return (
      <div>
        <div className={classes.row}>
          {headers.map(header => (
            <p key={uuidv4()} className={classes.headerText}>
              {`${header}`}
            </p>
          ))}
        </div>
        <div>
          {Array.from(balanceLogs).reverse().map(balanceLog => this.renderVoucher(balanceLog))}
        </div>
      </div>
    );
  }
}

export default (withStyles(styles)(RedemptionHistory));
